import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Textarea } from "../components/ui/textarea";
import { toast } from "sonner";
import { HelpCircle, Check, Pencil, SkipForward } from "lucide-react";

export default function Tier3() {
  const [items, setItems] = useState([]);
  const [custom, setCustom] = useState({});

  const load = async () => {
    const { data } = await api.get("/tier3");
    setItems(data);
  };
  useEffect(() => { load(); }, []);

  const resolve = async (id, action, customReply) => {
    try {
      await api.post(`/tier3/${id}/resolve`, { action, custom_reply: customReply || null });
      toast.success("Resolved.");
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed."); }
  };

  return (
    <div data-testid="tier3-page">
      <div className="mb-8">
        <div className="overline">Tier-3</div>
        <h1 className="font-display text-4xl mt-2">Reader questions held for you.</h1>
        <p className="mt-2 text-sm max-w-2xl" style={{ color: "var(--elle-ink-dim)" }}>
          Plot probes, theories that edge too close to Tier-2, or reader questions the agent is uncertain about.
          A deflection is drafted — approve it, write your own, or ignore.
        </p>
      </div>

      <div className="space-y-5">
        {items.length === 0 && (
          <div className="font-mono-elle text-sm" style={{ color: "var(--elle-ink-faint)" }}>
            No Tier-3 questions held.
          </div>
        )}
        {items.map((q) => (
          <article key={q.id} data-testid={`tier3-${q.id}`}
                   className="elle-surface p-6 rounded-sm">
            <div className="flex items-center justify-between">
              <div className="overline flex items-center gap-2">
                <HelpCircle size={14}/> {q.platform} · {q.author_handle}
              </div>
              <div className="text-xs font-mono-elle" style={{ color: "var(--elle-ink-faint)" }}>
                {new Date(q.received_at).toLocaleString()}
              </div>
            </div>
            <blockquote className="mt-3 pl-4 border-l text-base leading-relaxed"
                        style={{ borderColor: "var(--elle-border-strong)" }}>
              {q.question}
            </blockquote>
            <div className="mt-4">
              <div className="overline mb-2">Proposed deflection</div>
              <div className="elle-surface-2 p-4 rounded-sm text-sm italic"
                   style={{ color: "var(--elle-ink)" }}>
                "{q.proposed_deflection}"
              </div>
            </div>
            <Textarea data-testid={`tier3-custom-${q.id}`}
                      rows={2} className="mt-4"
                      placeholder="Or write a different reply…"
                      value={custom[q.id] || ""}
                      onChange={(e)=>setCustom({...custom, [q.id]: e.target.value})}/>
            <div className="mt-3 flex flex-wrap gap-2">
              <Button data-testid={`tier3-approve-${q.id}`}
                      onClick={() => resolve(q.id, "approve_deflection")}
                      className="btn-amber rounded-sm">
                <Check size={14} className="mr-2"/> Send deflection
              </Button>
              <Button data-testid={`tier3-custom-btn-${q.id}`}
                      onClick={() => resolve(q.id, "custom_reply", custom[q.id])}
                      disabled={!custom[q.id]}
                      className="btn-ghost rounded-sm" variant="outline">
                <Pencil size={14} className="mr-2"/> Send my reply
              </Button>
              <Button data-testid={`tier3-ignore-${q.id}`}
                      onClick={() => resolve(q.id, "ignore")}
                      className="btn-ghost rounded-sm" variant="outline">
                <SkipForward size={14} className="mr-2"/> Ignore
              </Button>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
